module.exports = __webpack_public_path__ + "static/img/13.db277dfb.png";